<template>
  <div>
     <van-form ref="searchform" class="contant">
        <van-cell-group inset>
          <!-- <van-field readonly clickable v-model="form.custTypeName"  label="客户类型" placeholder="请选择客户类型" disabled /> -->
          <van-field v-model="form.custName" label="客户名称" :rules="[{ required: true }]" placeholder="请填写客户名称" required />
        </van-cell-group>
      </van-form>
      <div class="btn_group">
        <van-button class="btn" round type="info" native-type="submit" size="small" @click="handleList">搜索</van-button>
        <van-button class="btn" round type="warning" native-type="button" size="small" @click="toWxCustList">企业微信获取</van-button>
        <!-- <van-button class="btn" round type="primary" native-type="button" size="small" @click="toScanCard">名片扫描</van-button> -->
      </div>
      <div class="tip" style="font-size:12px;margin-left: 20px;">
        <p style="line-height: 1.8;color: #666">
          1、请输入客户名称关键词进行搜索。<br/>
          2、已有客户请申请共享权限。<br/>
          3、新客户将直接跳转新建客户卡片页面。
        </p>
      </div>
      <div v-if="list.length>0" style="margin-top:-30px">
        <van-list v-model="loading" :finished="finished" finished-text="" v-hasPermi="['scrm:customer:list']" @load="onLoad" v-if="list.length > 0 && loading === false">
          <list-item @todetail="toCustBlueDetails" :isAdd = 'true' :listData="list" :dictOptions="options"/>
        </van-list>
      </div>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>

    <van-dialog v-model="showCust" class="cust" width="97%" style="height: 80%;overflow: scroll;" title="选择企业微信客户" :beforeClose="beforeClose" :showConfirmButton='false' :close-on-click-overlay="true">
      <div class="dialog_top">
        <van-button class="btn" type="info" native-type="submit" size="small" plain @click="syncCust" >同步企业微信客户</van-button>
      </div>
      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入客户名称搜索"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <van-list class="van-list" v-model="custLoading" style="height: 80%" :finished="custFinished" finished-text="没有更多了" @load="custOnLoad" v-if="custList.length > 0">
        <van-cell v-for="(item,index) in custList" :key="index" >
          <div class="flex-between">
            <div>
              <div class="custName-wrap"> <div class="custName"> {{ item.custName }} </div> </div>
              <div>
                <!-- <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custType">{{ formatHandel("custType",item.custType) }}</van-tag>
                <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custSource">{{ formatHandel("custSource",item.custSource) }}</van-tag>
                <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custStatus">{{ formatHandel("custStatus",item.custStatus) }}</van-tag> -->
                <!-- <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.custLevel">{{ formatHandel("custLevel", item.custLevel) }}</van-tag> -->
                <!---客户来源-->
                <!-- <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.industry" >{{ item.industry }}</van-tag>
                <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.unitNature">{{ formatHandel("unitNature", item.unitNature) }}</van-tag > -->
                <span style="color: #333; font-size: 12px">联系人：{{item.userName}}      职位：{{ item.custProfile || '-'}}      电话：{{item.phone || '-'}}</span>
              </div>
              <!-- <div><span style="color: #333; font-size: 12px"></span></div> -->
            </div>
            <van-button size="mini" type="warning" @click="selectCust(item)">新建</van-button>
          </div>
        </van-cell>
      </van-list>
      <empty-component v-if="isEmpty" />
    </van-dialog>
    <van-dialog v-model="showScanCard" class="cust" width="97%" style="height: 80%;overflow: scroll;" title="上传客户名片" :beforeClose="scanCardBeforeClose" :close-on-click-overlay="true">
      <div>功能开发中...敬请期待</div>
      <div class="upload_dialog">
        <van-uploader v-model="cardList" multiple :max-count="1" :after-read="uploadPicture" :before-read="beforeRead" :max-size="10000 * 1024" @oversize="onOversize" accept="application/jpeg,.jpg,.png," />
        <div class="upload_explain">
          <div>说明：</div>
          <div>1、附件要求：image(jpg,jpeg,png)格式且大小不超过10Mb;</div>
          <div>2、名片尽可能充满整个画面；拍摄时，请保持光线充足，不要有阴影和反光；请对焦后进行拍摄，尽量避免抖动；</div>
        </div>
      </div>
      <van-form ref="searchform" class="contant" :disabled="noUpload">
        <!-- <van-cell-group inset> -->
          <!-- <van-field readonly clickable v-model="form.custTypeName"  label="客户类型" placeholder="请选择客户类型" disabled /> -->
        <van-field v-model="form.custName" label="客户名称" :rules="[{ required: true }]" placeholder="请上传客户名片" required />
        <van-field v-model="form.custAddress" label="客户地址" placeholder="请上传客户名片" />
        <van-field v-model="contactList.contactName" label="联系人姓名" placeholder="请上传客户名片" />
        <van-field v-model="contactList.mobile" label="联系人手机" placeholder="请上传客户名片" />
        <van-field v-model="contactList.weixinSn" label="联系人微信号" placeholder="请上传客户名片" />
        <van-field v-model="contactList.jobs" label="联系人职务" placeholder="请上传客户名片" />
        <!-- </van-cell-group> -->
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import { listCust, selectAddListWx, getWxLoadList } from '@/api/scrm/mycust'
import { areaList } from '@vant/area-data'
import ListItem from '../component/ListItem.vue'
import { getDicts } from '@/api/system/dict/data'
import EmptyComponent from '@/components/common/Empty'
import { Toast, Dialog } from 'vant'
import payment from '@/api/cont/payment'
export default {
  name: 'custClue',
  components: {
    ListItem,
    EmptyComponent,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      isEmpty: false,
      picker: {
        visible: false,
        visibleIndustry: false,
        title: '',
        columns: [],
        formKey: '',
        areaList
      },
      loading: false,
      finished: false,
      list: [],
      show: false,
      type: 'add',
      showFilterPop: false,
      searchValue: '',
      showCust: false,
      custList: [],
      custLoading: false,
      custFinished: false,
      total: 0,
      custParams: {
        pageNum: 1,
        pageSize: 10
      },
      showScanCard: false,
      cardList: [],
      noUpload: true,
      options: {
        // 客户类型字典
        custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
        // 客户来源字典
        custSourceOptions: this.$store.state.dictOptions.custSource || [],
        // 客户状态
        custStatusOptions: this.$store.state.dictOptions.custStatus || [],
        // 行业类型
        businessTypeOptions: this.$store.state.dictOptions.businessType || []
      },
      form: {
        custType: 1,
        custName: null,
        custTypeName: '客户',
        isAll: 1,
        isAdd: 1,
        orderByColumn: 'createTime',
        isAsc: 'desc',
        isSelCustName: 1
      },
      contactList: {},
      queryParams: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '客户管理-新建客户'
    },
    toCustBlueDetails(row) {
      // if(row.userId == this.$store.state.user.userId){
      //   this.msgError("无法申请已有客户");
      //   return;
      // }
      // row.shareUserId = this.$store.state.user.userId
      // batchApplyShare(row).then(response => {
      //   this.msgSuccess("申请成功");
      //   this.$router.push("share?code=0")
      // });
    },
    showPicker(type) {
      this.picker.formKey = type
      if (this.options.custTypeOptions.length) {
        if (type === 'custType') {
          this.picker.columns = this.options.custTypeOptions.map((ele) => ele.dictLabel)
        }
      } else {
        getDicts('crm_mycust_type').then(res => {
          this.options.custTypeOptions = res.data
          if (type === 'custType') {
            this.picker.columns = this.options.custTypeOptions.map((ele) => ele.dictLabel)
          }
        })
      }
      this.picker.visible = true
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === 'custType') {
        this.form.custType = this.options.custTypeOptions[index].dictValue
        this.form.custTypeName = this.options.custTypeOptions[index].dictLabel
      }
      this.picker.visible = false
    },
    areaConfirm(values) {
      this.form.areaId = values[values.length - 1].code
      this.form.areaName = values[values.length - 1].name
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    pickerChange() { },
    addCust() {
      this.show = true
    },
    async handleList() {
      this.loading = true
      await this.$refs.searchform.validate()
      const res = await listCust(this.form)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          // this.$router.push('/scrm/myCust/addInfos?custType=' + this.form.custType +
          //  '&custName=' + this.form.custName + '&custTypeName=' + this.form.custTypeName +
          //  '&contactList=' + JSON.stringify(this.contactList) + '&from=' + this.$route.query.from || null)
          await this.getExecCustomerByName()
        }
        this.list = res.rows
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    async getExecCustomerByName() {
      const that = this
      await payment.getExecCustomerByName(this.form.custName).then(res => {
        if (res.code === 200) {
          if (res.msg) {
            Dialog.confirm({
              title: '提示信息',
              confirmButtonText: '继续添加',
              message: '<span style="color: #E6A23C;">' + res.msg + '</span>'
            }).then(() => {
              that.$router.push('/scrm/myCust/addInfos?custType=' + that.form.custType +
                '&custName=' + that.form.custName + '&custTypeName=' + that.form.custTypeName +
                '&contactList=' + JSON.stringify(that.contactList) + '&from=' + that.$route.query.from || null)
            }).catch(() => {

            })
          } else {
            that.$router.push('/scrm/myCust/addInfos?custType=' + that.form.custType +
              '&custName=' + that.form.custName + '&custTypeName=' + that.form.custTypeName +
              '&contactList=' + JSON.stringify(that.contactList) + '&from=' + that.$route.query.from || null)
          }
        }
      })
    },
    onLoad() {
      this.handleList()
    },
    async syncCust() {
      const res = await selectAddListWx()
      if (res.code === 200) {
        this.queryCustList()
      }
    },
    async toWxCustList() {
      await this.handCustList()
      this.showCust = true
    },
    toScanCard() {
      this.showScanCard = true
    },
    async handCustList() {
      this.custLoading = true
      const res = await getWxLoadList(this.custParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.custList = this.custList.concat(...res.rows)
        this.custParams.pageNum += 1
        this.total = res.total
        this.custFinished = this.custList.length >= res.total
        this.custLoading = false
      }
    },
    custOnLoad() {
      this.handCustList()
    },
    QueryReset() {
      this.custParams = {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    },
    queryCustList() {
      this.custList = []
      this.custParams.pageNum = 1
      this.handCustList()
    },
    onSearch() {
      this.isEmpty = false
      this.QueryReset()
      this.custParams.custName = this.searchValue
      this.queryCustList()
    },
    beforeClose() {
      this.showCust = false
    },
    selectCust(item) {
      this.form.custName = item.custName
      this.contactList.contactName = item.userName
      this.contactList.mobile = item.phone
      this.contactList.jobs = item.custProfile
      this.showCust = false
      this.handleList()
    },
    // 返回布尔值
    beforeRead(file) {
      // console.log(file)
      const fileArr = ['image/jpeg', 'image/png']
      if (!fileArr.some((item) => { return file.type === item })) {
        Toast('请上传格式为 jpg/jpeg/png 的图片')
        return false
      }
      return true
    },
    onOversize(file) {
      Toast.fail('图片大小不能超过 10mb')
    },
    async uploadPicture(file) {
      // this.form.fileName = file.file.name
      // if(this.index || this.index == 0){
      //   this.form.fileList[this.index].fileName = file.file.name
      // }
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)

      // await newContract.uploadContractFile(formData)
      //   .then((res) => {
      //     if (res.code === 200) {
      //       this.form.fileList[this.index].fileName = file.file.name
      //       this.form.fileList[this.index].url = res.url
      //       Toast.success(res.msg)
      //     } else {
      //       Toast.fail('res.msg')
      //     }
      //   })
      //   .catch(function (error) {
      //     console.error(error)
      //   })
    },
    scanCardBeforeClose() {
      this.showScanCard = false
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.btn_group{
  display: flex;
  align-items: center;
  justify-content: space-around;
  .btn{
    width: 30%;
    border-radius: 10px;
  }
}
.van-list{
  margin-top: -120px;
}
.dialog_top{
  // width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
  .btn{
    border-radius: 16px;
  }
}
.upload_dialog{
  padding: 20px 30px;
  display: flex;
  align-items: flex-start;
  .upload_explain{
    background-color: #f5f7f9;
    font-size: 22px;
    color: #999;
    padding: 5px 10px;
    line-height: 30px;
  }
}
</style>
